<template>
  <a-modal
    title="请选择身份"
    :width="450"
    :visible="visible"
    :closable="false"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form>
      <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" style="margin-bottom: 10px">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>您有多个身份，请选择用户身份</span>
          </template>
          <a-avatar style="background-color: #87d068" icon="gold" />
        </a-tooltip>

        <a-select
          @change="handleTenantChange"
          placeholder="请选择用户身份"
          style="margin-left: 10px; width: 80%"
          v-model:value="identityId"
        >
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option v-for="item in userIdentityList" :key="item.value" :value="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { getAction } from '@/api/manage'
import { mapActions } from 'vuex'
import { IDENTITY_ID, USER_INFO, TENANT_ID } from '@/store/mutation-types'

export default {
  name: 'SwitchIdentity',
  data() {
    return {
      visible: false,
      tenantList: [],
      identityId: '',
      userIdentityList: [],
      currIderntity: '',
    }
  },
  methods: {
    show() {
      this.currIderntity = Vue.ls.get(USER_INFO).userIdentity.split(',')
      this.identityId = Vue.ls.get(IDENTITY_ID) || this.currIderntity[0]
      this.initUserIdentityList()
      this.visible = true
    },
    initUserIdentityList() {
      getAction('/sys/dict/getDictItems/userIdentity').then((res) => {
        if (res.success) {
          this.userIdentityList = res.result.filter((item) => {
            return (
              this.currIderntity.includes(item.value) && ['1', '2', '3', '6'].includes(item.value)
            )
          })
        }
      })
    },
    handleOk() {
      this.visible = false
      const currIderntity = this.userIdentityList.find((item) => item.value === this.identityId)
      this.$store.dispatch('saveCurrIdentity', this.identityId)
      this.$notification.success({
        message: '切换身份成功',
        description: `当前用户身份为：${currIderntity.title}`,
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleTenantChange(e) {
      this.identityId = e
    },
  },
}
</script>

<style scoped></style>
